export const today     = () => new Date().toISOString().split('T')[0];
export const yearStart = () => `${new Date().getFullYear()}-01-01`;

export const fmt = (v) =>
  Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

export const fmtM = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1_000_000) return (n / 1_000_000).toFixed(1).replace('.', ',') + ' M';
  if (Math.abs(n) >= 1_000)     return (n / 1_000).toFixed(0) + ' K';
  return fmt(n);
};

// Formate un montant selon l'unité choisie par section (Auto/MAD/kMAD/MMAD)
export const fmtUnit = (v, unit) => {
  const n = Number(v || 0);
  if (unit === 'mad')  return fmt(n);
  if (unit === 'kmad') return fmt(Math.round(n / 1000)) + ' k';
  if (unit === 'mmad') return (n / 1_000_000).toFixed(1).replace('.', ',') + ' M';
  return fmtM(n);
};

export const UNIT_LABELS = { default: 'Auto', mad: 'MAD', kmad: 'kMAD', mmad: 'MMAD' };

export const fmtDate = (v) => {
  if (!v) return '—';
  const s = typeof v === 'string' ? v : v instanceof Date ? v.toISOString() : String(v);
  const d = s.slice(0, 10);
  if (!d || d === '0000-00-00') return '—';
  const [y, m, day] = d.split('-');
  return `${day}/${m}/${y}`;
};

export const fmtLabel = (m) => {
  if (!m) return '';
  const [y, mo] = m.split('-');
  const moisFr = ['Jan','Fév','Mar','Avr','Mai','Jun','Jul','Aoû','Sep','Oct','Nov','Déc'];
  return `${moisFr[parseInt(mo, 10) - 1]} ${y}`;
};

// Calcul sur les chaînes 'YYYY-MM' (pas de new Date) : indépendant du fuseau horaire du navigateur
export const genMonths = (debut, fin) => {
  const months = [];
  if (!debut || !fin) return months;
  let y = parseInt(debut.slice(0, 4), 10), m = parseInt(debut.slice(5, 7), 10);
  const yf = parseInt(fin.slice(0, 4), 10), mf = parseInt(fin.slice(5, 7), 10);
  while (y < yf || (y === yf && m <= mf)) {
    months.push(`${y}-${String(m).padStart(2, '0')}`);
    if (++m > 12) { m = 1; y++; }
  }
  return months;
};

export const toOpt    = (arr, vKey = 'id', lKey = 'name') =>
  (arr || []).map(r => ({ value: r[vKey], label: r[lKey] }));
export const toOptStr = (arr) => (arr || []).map(v => ({ value: v, label: v }));
